import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { PostSaveOptInModal, PhoneVerification } from '@adc/ui-adc'
import type {
  primitives,
  AuctionBlueprintOnlineReactiveArgs,
} from '@adc/blueprint'
import { toggleOptinModal } from '../actions/modals'
import { updatePhoneValue, PHONE_FIELDS } from '../actions/user'

interface SMSOptInModalProps
  extends Omit<AuctionBlueprintOnlineReactiveArgs, 'segment'> {
  closeModal: () => void
  onPhoneVerify: (latestPhoneNumber: number, shouldUpdate: boolean) => void
  shouldDisplayModal: boolean
  updateVerifiedPhoneOptIn: (
    latestPhoneNumber: number,
    shouldUpdate: boolean
  ) => void
  user: primitives.AuctionUser
}

const SMSOptInModal = ({
  closeModal,
  listing,
  onPhoneVerify,
  shouldDisplayModal,
  updateVerifiedPhoneOptIn,
  user,
}: SMSOptInModalProps) => {
  if (!shouldDisplayModal || !user.logged_in) {
    return null
  }

  const userId = user.user_id

  const onConfirm = (latestPhoneNumber: number) => {
    updateVerifiedPhoneOptIn(latestPhoneNumber, true)
    closeModal()
  }

  const onVerificationSuccess = (newPhone: { number: number }) => {
    onPhoneVerify(newPhone.number, true)
  }

  const latestPhone =
    PhoneVerification.utils.getLatestPhone(user.party?.phones) || {}
  const isForeclosure = listing?.event?.trustee_sale
  const partyId = user.party_id
  const trackingInfo = useMemo(
    () => ({
      userId,
      morpheusListingId: listing.listing_id,
      morpheusPropertyId: listing.primary_property.property_id,
    }),
    [userId, listing.listing_id, listing.primary_property.property_id]
  )

  return partyId ? (
    <PostSaveOptInModal
      open
      onConfirm={onConfirm}
      onClose={closeModal}
      partyId={partyId}
      latestPhone={latestPhone}
      onVerificationSuccess={onVerificationSuccess}
      isForeclosureOnline={isForeclosure}
      trackingInfo={trackingInfo}
    />
  ) : null
}

const mapStateToProps = (store: any) => ({
  listing: store.listing,
  shouldDisplayModal: store.modals.smsOptInModalOpen,
  user: store.user,
})

const mapDispatchToProps = (dispatch: any) => ({
  onPhoneVerify: (number: number, value: boolean) =>
    dispatch(updatePhoneValue(number, PHONE_FIELDS.verified, value)),
  closeModal: () => dispatch(toggleOptinModal(false)),
  updateVerifiedPhoneOptIn: (number: number, value: boolean) =>
    dispatch(updatePhoneValue(number, PHONE_FIELDS.optIn, value)),
})

export default connect<
  Pick<SMSOptInModalProps, 'listing' | 'shouldDisplayModal' | 'user'>,
  Pick<
    SMSOptInModalProps,
    'closeModal' | 'updateVerifiedPhoneOptIn' | 'onPhoneVerify'
  >
>(
  mapStateToProps,
  mapDispatchToProps
)(SMSOptInModal)
